/* rf-reveal.js — shared staggered scroll-reveal for [data-rf-reveal] elements
   (P2-4v). Children carry inline transition-delay (60–80ms steps) so grids
   stagger; whole-section fades are banned. No-JS / reduced-motion: content
   simply shows (rf-pre is only ever added here). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init() {
    var els = document.querySelectorAll('[data-rf-reveal]');
    els.forEach(function (el) { el.classList.add('rf-pre'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('rf-pre'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8%' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
